import React from "react";
import { IoPersonOutline } from "react-icons/io5";
import { LiaIdCardSolid, LiaPhoneVolumeSolid } from "react-icons/lia";
import { TiBusinessCard } from "react-icons/ti";
import { TfiEmail } from "react-icons/tfi";
import { PiUserList } from "react-icons/pi";

export const MisDatos = () => {
    return (

        <div class="container-datos">

            <div className="container-title">
                <PiUserList size={'18px'} />
                Mis datos
            </div>

            {/* <!-- Tarjeta: Información de contacto --> */}
            <div class="card-datos">
                <div class="card-header-datos">Información de contacto</div>
                <div class="card-content-datos">
                    <ul>
                        <li>
                            <span className="icon-circle-datos"><IoPersonOutline /></span>
                            <strong style={{color:'#727272'}}>Nombre:</strong> Manuel Toshio Fukushima Aguilar
                        </li>
                        <li>
                            <span className="icon-circle-datos"><LiaIdCardSolid /></span>
                            <strong style={{color:'#727272'}}>Tipo Documento:</strong> DNI
                        </li>
                        <li>
                            <span className="icon-circle-datos"><TiBusinessCard /></span>
                            <strong style={{color:'#727272'}}>Nro. Documento:</strong> 4444444
                        </li>
                        <li>
                            <span className="icon-circle-datos"><TfiEmail /></span>
                            <strong style={{color:'#727272'}}>E-mail:</strong> <a href="mailto:manueltoshio@hotmail.com">manueltoshio@hotmail.com</a>
                        </li>
                        <li>
                            <span className="icon-circle-datos"><LiaPhoneVolumeSolid /></span>
                            <strong style={{color:'#727272'}}>N° Teléfono:</strong> +51 948 390 732
                        </li>
                    </ul>
                </div>
                <div class="edit-link-datos pointer" href="#">
                    Editar
                </div>
            </div>

            {/* <!-- Tarjeta: Mis Direcciones --> */}
            <div class="card-datos" style={{ marginTop: '35px', marginBottom: '30px' }}>
                <div class="card-header-datos">Mis Direcciones</div>
                <div class="card-content-datos">
                    <div class="direccion-item-datos">
                        <input type="radio" name="direccion" checked />
                        <div>
                            <strong>CASA</strong><br />
                            <span style={{color:'#727272'}}>TRUJILLO, Pizarro 450</span>
                        </div>
                    </div>
                </div>

                <div class="edit-link-datos pointer" href="#">
                    {/* <div>Agregar Dirección +</div> */}
                    <div className="actions-datos">
                        <div>Editar</div>
                        <div>Agregar Dirección +</div>
                    </div>
                </div>
            </div>

            <div className="dashed-line"></div>

        </div>
    )
}